// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { Language, ActionableFiltersForm } from "../schema";
import { serialize_Language_internal, deserialize_Language_internal } from "./Language";

export function serialize_ActionableFiltersForm_internal(value: ActionableFiltersForm): unknown {
  return ((value: { languageFormFilter: Language[] }): unknown => {
    return {
      languageFormFilter: ((value: Language[]): unknown => {
        return value.map((value: Language): unknown => {
          return serialize_Language_internal(value);
        });
      })(value["languageFormFilter"]),
    };
  })(value);
}
export function serialize_ActionableFiltersForm(obj: ActionableFiltersForm): string {
  return renderJsonWithNumbersAsBigint(serialize_ActionableFiltersForm_internal(obj));
}
export function deserialize_ActionableFiltersForm_internal(value: unknown): ParserResult<ActionableFiltersForm> {
  return ((
    value: unknown,
  ): ParserResult<{
    languageFormFilter: Language[];
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ActionableFiltersForm]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ActionableFiltersForm]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "languageFormFilter")) {
      return { success: false, reason: `[#/components/schemas/ActionableFiltersForm/languageFormFilter]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'languageFormFilter'.` };
    }
    const parsed_languageFormFilter = ((): ParserResult<Language[]> => {
      return ((value: unknown): ParserResult<Language[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/ActionableFiltersForm/languageFormFilter]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<Language> => {
          return deserialize_Language_internal(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/ActionableFiltersForm/languageFormFilter]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["languageFormFilter"]);
    })();
    if (!parsed_languageFormFilter.success) {
      return { success: false, reason: parsed_languageFormFilter.reason };
    }
    return { success: true, value: { languageFormFilter: parsed_languageFormFilter.value } };
  })(value);
}
export function deserialize_ActionableFiltersForm(str: string): ParserResult<ActionableFiltersForm> {
  return deserialize_ActionableFiltersForm_internal(parseJsonWithNumbersAsBigint(str));
}
